import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-indigo-900/70 z-10" />
        <img 
          src="/images/ref.png" 
          alt="Coding workspace with city view" 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Content Container */}
      <div className="container mx-auto px-6 relative z-20">
        <div className={`max-w-2xl transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-sm font-mono tracking-wider text-indigo-400 mb-2">Full Stack Developer (React, Python, SQL)</h2>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Hi, I'm Ariane
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            I turn ideas into scalable web applications.
            Specializing in full stack development with React, Python, and SQL to build responsive, efficient, and user-friendly solutions.
          </p>
          
          <div className="flex flex-wrap gap-4">
             <a href="#projects">
            <button className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors">
              View My Projects
            </button>
            </a>
             <a href="#contact">
            <button className="px-6 py-3 bg-transparent border border-white/30 hover:bg-white/10 text-white font-medium rounded-lg transition-colors">
              Contact Me
            </button>
            </a>
          </div>
          
          {/* Tech Stack Pills */}
          <div className="mt-12">
            <p className="text-sm text-gray-400 mb-3">Tech Stack</p>
            <div className="flex flex-wrap gap-2">
              {['React','Python', 'APIs', 'JavaScript', 'Tailwind CSS', 'SQL', 'SaaS'].map((tech) => (
                <span key={tech} className="px-3 py-1 bg-white/10 text-sm text-gray-300 rounded-full">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}